import { themeQuartz } from 'ag-grid-community';

// Aligned with Tailwind gray palette used across the admin UI
// Page bg: gray-900 (#111827), Sidebar: gray-800 (#1f2937)
// Text: gray-300 (#d1d5db), Muted: gray-400 (#9ca3af)
export const adminGridTheme = themeQuartz.withParams({
  backgroundColor: '#111827',        // gray-900 — matches page bg
  foregroundColor: '#d1d5db',         // gray-300
  headerBackgroundColor: '#1f2937',   // gray-800
  headerTextColor: '#9ca3af',         // gray-400
  headerFontSize: 12,
  headerFontWeight: 600,
  rowHoverColor: '#1f2937',           // gray-800
  selectedRowBackgroundColor: '#374151', // gray-700
  borderColor: '#1f2937',             // gray-800
  borderRadius: 8,
  cellTextColor: '#d1d5db',           // gray-300
  oddRowBackgroundColor: '#111827',   // gray-900
  fontSize: 13,
  rowBorder: { color: '#1f2937', width: 1 },  // gray-800
  columnBorder: false,
  wrapperBorderRadius: 8,
  spacing: 6,
});
